import { tenantApi } from '@/modules/tenant/services/tenantApi';
import type { InventoryStatus } from '../types/boat.types';

// Phase 50: canonical route is /statuses; backend keeps /internal-statuses as
// a legacy alias for one release cycle (drop in Phase 51 cleanup).
export const inventoryStatusApi = {
  getStatuses: (params?: {
    page?: number;
    per_page?: number;
    search?: string;
    is_active?: boolean;
  }) => tenantApi.getPaginated<InventoryStatus>('/statuses', { params }),

  getStatus: (id: string) =>
    tenantApi.getOne<InventoryStatus>(`/statuses/${id}`),

  createStatus: (payload: Partial<InventoryStatus>) =>
    tenantApi.postOne<InventoryStatus>('/statuses', payload),

  updateStatus: (id: string, payload: Partial<InventoryStatus>) =>
    tenantApi.putOne<InventoryStatus>(`/statuses/${id}`, payload),

  deleteStatus: (id: string) =>
    tenantApi.deleteOne(`/statuses/${id}`),
};
